var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.module.base.s == 0),expression:"module.base.s == 0"}],staticClass:"item-style1"},[_c('Index1',{attrs:{"module":_vm.module}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }